import NativeBridgeSpeechRecognition, { setWebViewRecognition } from './NativeBridgeSpeechRecognition';

// React Native app only. Must be imported before react-speech-recognition is evaluated (first
// import of src/index.js) so the library picks this class up as "the browser's" SpeechRecognition.
// In a normal browser this does nothing — the browser's own API is left untouched.
//
// The Android WebView does have its own webkitSpeechRecognition, but handing it to the library
// directly loses every phrase when offline (see NativeBridgeSpeechRecognition). So the app class is
// always installed here and drives the WebView's engine itself, falling back to the native module
// when the WebView has none.

function takeOver(name) {
  try {
    window[name] = NativeBridgeSpeechRecognition;
    if (window[name] === NativeBridgeSpeechRecognition) return;
  } catch (e) { /* not writable in this WebView — define it instead */ }
  try {
    Object.defineProperty(window, name, { value: NativeBridgeSpeechRecognition, configurable: true, writable: true });
  } catch (e) { /* leave the WebView's own engine in place */ }
}

if (typeof window !== 'undefined' && (window.ReactNativeWebView || window.isNativeApp)) {
  // Never let voice typing break app start-up: worst case the library meets the raw engine as before.
  try {
    // Keep a handle on the WebView's own engine BEFORE replacing the globals the library reads.
    setWebViewRecognition(window.SpeechRecognition || window.webkitSpeechRecognition || null);
    takeOver('SpeechRecognition');
    takeOver('webkitSpeechRecognition');
  } catch (e) { /* voice typing keeps the WebView's own engine */ }
}
